import { ComponentHeader } from '../shared/ComponentHeader'
import { ComponentTitle } from '../shared/ComponentTitle'
import clsx from 'clsx'
import { ComponentActionsContainer } from '../shared/ComponentActionsContainer'
import { getComponentHeights } from '../utils'
import { WordCloudDataSchema, WordCloudUISchema } from './types'
import { WordCloudBody } from './WordCloudBody'
import { WordCloudSphereBody } from './WordCloudSphereBody'

export function WordCloudContent({
  uiSchema,
  dataSchema,
  tileFilters,
}: {
  uiSchema: WordCloudUISchema
  dataSchema: WordCloudDataSchema
  tileFilters?: React.ReactNode
}) {
  const { title = undefined, description = undefined, emphasizeHeader } = uiSchema
  const hasHeader = !!title && !!tileFilters
  const { contentHeight } = getComponentHeights(emphasizeHeader, hasHeader)

  return (
    <div className="flex h-full flex-col">
      {hasHeader && (
        <ComponentHeader emphasize={emphasizeHeader}>
          <ComponentTitle title={title} description={description} />
          <ComponentActionsContainer>{tileFilters}</ComponentActionsContainer>
        </ComponentHeader>
      )}
      <div className={clsx({ 'pt-5': hasHeader })} style={{ height: contentHeight }}>
        {uiSchema.wordCloudConfig.layout === 'sphere' ? (
          <WordCloudSphereBody config={uiSchema.wordCloudConfig} words={dataSchema.data} />
        ) : (
          <WordCloudBody config={uiSchema.wordCloudConfig} words={dataSchema.data} />
        )}
      </div>
    </div>
  )
}
